<h1 mat-dialog-title>Hash取得教學</h1>
<div mat-dialog-content>
  <div>
    <a href="https://payment.opay.tw/Broadcaster/Setup" class="href">https://payment.opay.tw/Broadcaster/Setup</a>
    登入此網址取得Hash
  </div>
  <img src="https://i.imgur.com/GfHDyHb.png" id="img">
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>關閉</button>
</div>
